<div class="cm-landing-fixed-width cm-hero-section">
	<h1>
		Start using CropManage in 4 easy steps
	</h1>
	<p>
		CropManage helps you set up your farm so you can quickly start
		getting irrigation and nitrogen recommendations.
		Here’s how to get started:
	</p>
</div>
<div class="cm-landing-fixed-width cm-step-1">
	<h2>
		Step 1 - Create a ranch
	</h2>
	<p>
		A ranch in CropManage represents your farm.
	</p>
	<ul>
		<li>Add a ranch name and choose its location on the map.</li>
		<li>Select a weather station.</li>
		<li>Choose fertilizers from a list or add your own.</li>
		<li>Choose a crop type.</li>
		<li>Add water sources (e.g. well., canal, or reservoir water).</li>
		<li>Customize the list of crops you grow.</li>
	</ul>

	<img src="../../../../assets/images/illustrations/ranch settings.png" width="867" height="288"/>
</div>
<div class="cm-landing-fixed-width cm-step-1">
	<h2>
		Step 2 - Create a planting
	</h2>
	<p>
		In CropManage, a planting is a specific crop in one of your fields
		or orchards that you want to manage.
	</p>
	<ul>
		<li>Choose a crop type.</li>
		<li>Enter the start and end dates for the season.</li>
		<li>Add irrigation methods you’ll use (e.g., drip, sprinklers).</li>
	</ul>
	<div class="cm-youll-need-subsection">
		<span>
			<mat-icon class="material-symbols-outlined">service_toolbox</mat-icon> 
			You'll need:
		</span>

		<ul>
			<li>Application rates and distribution uniformity of your
			irrigation system</li>
			<li>Leaching fraction (if your irrigation water has significant salts)</li>
			<li>Expected yield (for some tree and fruit crops such as almond,
				grape, and strawberry)</li>
		</ul>
	</div>

	<img src="../../../../assets/images/illustrations/create planting.png" width="867" height="288"/>
</div>
<div class="cm-landing-fixed-width cm-step-1">
	<h2>
		Step 3 - Add irrigation events
	</h2>
	<ul>
		<li>Enter the irrigation date.</li>
		<li>Select the irrigation method (e.g. drip, sprinkler).</li>
	</ul>
	<div class="cm-info-box">
		<mat-icon class="material-symbols-outlined">info</mat-icon>
		<p>
			Once you select the date and method, <strong>CropManage will
			display a recommendation</strong> for how much to irrigate.
		</p>
	</div>
</div>
<div class="cm-landing-fixed-width cm-step-1">
	<h2>
		Step 4 - Add fertilization events
	</h2>
	<ul>
		<li>Enter the fertilization date.</li>
		<li>Select a fertilizer from a list.</li>
		<li>Enter the number of days until the next application.</li>
		<li>(Optional)  Enter a nitrate value from a recent soil sample to
			refine recommendations.</li>
		<li>
			(Optional) Take credit for nitrogen in irrigation water.
		</li>
	</ul>
	<div class="cm-info-box">
		<mat-icon class="material-symbols-outlined">info</mat-icon>
		<p>
			Once you've entered the required inputs, <strong>CropManage will
			display a recommendation</strong> for how much nitrogen to apply.	
		</p>
	</div>
</div>
<div class="cm-landing-fixed-width cm-closing">
	<p>
		With these steps, you’re ready to start using CropManage. Feel free to
		explore additional inputs and options as you go. For more
		guidance, visit our <a >Tutorials Page</a> or <a>Contact Us</a> for technical support.
	</p>
</div>
